<template>
  <div class="color-type">
    <div class="box-preview">
      <div class="preview" :style="previewStyle"></div>
    </div>
    <div class="box-input">
      <input
        type="text"
        class="value"
        :value="modelColor"
        @blur="onBlurInputColor"
        @keyup="onInputModelColor"
        @paste="onPasteInputColor"
        @keyup.enter="onBlurInputColor" />
      <div class="box-clear">
        <div class="clear" @click="clear">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.85355 9.64645C9.65829 9.45118 9.34171 9.45118 9.14645 9.64645C8.95118 9.84171 8.95118 10.1583 9.14645 10.3536L11.2929 12.5L9.14645 14.6464C8.95118 14.8417 8.95118 15.1583 9.14645 15.3536C9.34171 15.5488 9.65829 15.5488 9.85355 15.3536L12 13.2071L14.1464 15.3536C14.3417 15.5488 14.6583 15.5488 14.8536 15.3536C15.0488 15.1583 15.0488 14.8417 14.8536 14.6464L12.7071 12.5L14.8536 10.3536C15.0488 10.1583 15.0488 9.84171 14.8536 9.64645C14.6583 9.45118 14.3417 9.45118 14.1464 9.64645L12 11.7929L9.85355 9.64645Z"
              fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 5.5C8.13401 5.5 5 8.63401 5 12.5C5 16.366 8.13401 19.5 12 19.5C15.866 19.5 19 16.366 19 12.5C19 8.63401 15.866 5.5 12 5.5ZM6 12.5C6 9.18629 8.68629 6.5 12 6.5C15.3137 6.5 18 9.18629 18 12.5C18 15.8137 15.3137 18.5 12 18.5C8.68629 18.5 6 15.8137 6 12.5Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
    <div class="box-alpha">
      <input
        :key="keyInputAlpha"
        :value="modelAlpha"
        type="number"
        class="input--alpha gf_remove-spin-button"
        min="0"
        max="100"
        @focus="isFocusInputAlpha = true"
        @focusout="onBlurInputAlpha"
        @blur="onBlurInputAlpha"
        @keyup="onKeyUpInputAlpha"
        @keyup.enter="onBlurInputAlpha" />
      <span class="percent">%</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    alpha: {
      type: Number,
      default: 1,
    },
    rgbaString: {
      type: String,
      default: '',
    },
  },
  emits: ['inputColor'],
  data() {
    return {
      modelAlpha: 0,
      modelColor: '',
      keyInputAlpha: 0,
      isFocusInputAlpha: false,
    };
  },
  computed: {
    previewStyle() {
      return {
        background: this.rgbaString,
        border: `1px solid ${
          this.$tinycolor(this.rgbaString).isDark()
            ? this.$tinycolor.mix(this.rgbaString, 'white', 30).toHex8String()
            : this.$tinycolor.mix(this.rgbaString, 'black', 30).toHex8String()
        }`,
      };
    },
  },
  watch: {
    alpha(val) {
      if (!this.isFocusInputAlpha || (0 <= this.modelAlpha && this.modelAlpha <= 100) || (0 < val && val < 1)) {
        this.modelAlpha = Math.round(val * 100);
      }
    },
    color(val) {
      if (!this.isFocusInputAlpha) {
        this.onBlurInputAlpha();
      }
      this.modelColor = val;
    },
  },
  created() {
    this.modelAlpha = Math.round(this.alpha * 100);
    this.modelColor = this.color;
  },
  methods: {
    clear() {
      const defaultColor = '#FFFFFF';
      const defaultAlpha = 100;
      this.$emit('inputColor', defaultColor);
      this.modelColor = defaultColor;
      this.modelAlpha = defaultAlpha;
    },
    onPasteInputColor(event) {
      const value = event.clipboardData.getData('text');
      if (this.$tinycolor(value).isValid()) {
        this.$emit('inputColor', value);
        this.modelColor = value;
        event.target.blur();
        setTimeout(() => {
          event.target.focus();
        });
      }
    },
    onInputModelColor(event) {
      const value = event.target.value;
      if (this.modelColor == value) {
        return;
      }
      this.modelColor = value;
      if (this.$tinycolor(value).isValid()) {
        this.$emit('inputColor', value);
      }
    },
    onBlurInputColor(event) {
      const isHex6Color = function (color) {
        return /^#([0-9a-f]{6}){1}$/i.test(color);
      };

      const value = event.target.value;
      if (this.$tinycolor(value).isValid() && !isHex6Color(value)) {
        this.modelColor = this.$tinycolor(value).toHexString().toUpperCase();
        if (this.modelColor != this.color) {
          this.$emit('inputColor', this.$tinycolor(value));
        }
        this.modelAlpha = Math.round(this.$tinycolor(value).getAlpha() * 100);
      }
    },
    onKeyUpInputAlpha(event) {
      const value = event.target.value;
      this.modelAlpha = value;
      let opacity = value / 100;
      if (opacity < 0 || isNaN(opacity)) {
        opacity = 0;
      } else if (opacity > 1) {
        opacity = 1;
      }
      this.$emit('inputAlpha', opacity);
    },
    onBlurInputAlpha() {
      this.isFocusInputAlpha = false;
      if (this.modelAlpha < 0 || isNaN(this.modelAlpha) || !this.modelAlpha || !parseInt(this.modelAlpha)) {
        this.modelAlpha = 0;
      } else if (this.modelAlpha > 100) {
        this.modelAlpha = 100;
      }
      this.keyInputAlpha++;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.color-type {
  display: flex;
  margin-top: 12px;
  font-size: 12px;
  position: relative;

  .name {
    @include flex-center;
    width: 60px;
    height: 32px;
    float: left;
    color: #999;
    border: 1px solid #848484;
    box-sizing: border-box;
    border-radius: $radius;
  }

  .value {
    height: 32px;
    min-width: 100px;
    padding: 0 10px 0 30px;
    color: #fff;
    background: #494949;
    border: unset;
    box-sizing: border-box;
    border-radius: $radius 0 0 $radius;
    border-right: none;
    width: calc(100% - 32px);
  }

  .input--alpha {
    height: 32px;
    color: #fff;
    background: #494949;
    border: unset;
    box-sizing: border-box;
    width: 48px;
    padding: 0 18px 0 6px;
    font-size: 12px;
    text-align: center;
  }
}

.box-preview {
  background-image: url('/editor/static/icons/transparent-color.svg');
  position: absolute;
  top: 9px;
  left: 7px;
  width: 16px;
  height: 16px;
}

.preview {
  width: 100%;
  height: 100%;
}

.box-input {
  display: flex;
  width: 100%;
  border: unset;
  border: 1px solid #848484;
  &:hover {
    border: 1px solid map-get($hybrid-shade-light, '500') !important;
    .box-clear {
      display: block;
    }
  }
}
.box-clear {
  display: none;
  width: 32px;
  height: 32px;
}
.clear {
  position: absolute;
  right: 52px;
  top: 4px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.box-alpha {
  display: flex;
  align-items: center;
  color: #ffffff;
  position: relative;
  border: 1px solid #848484;
  border-left: unset;
  border-radius: 0 $radius $radius 0;
  &:hover {
    border: 1px solid map-get($hybrid-shade-light, '500') !important;
  }
  .percent {
    position: absolute;
    right: 6px;
    top: 6px;
  }
}
</style>
